export function isMobile () {
  return document.querySelector('body').offsetWidth < 768;
}

export function isDesktop () {
  return document.querySelector('body').offsetWidth >= 1200;
}
